import { Box, Typography } from '@mui/material';
import { RULES, type RuleGroup, type RuleId } from '@serb/shared';
import { DataTable } from '../../components/DataTable';
import { Panel } from '../../components/Panel';
import { NumberInput } from './NumberInput';

const GROUPS: { group: RuleGroup; subtitle?: string }[] = [
  {
    group: 'Active or inactive',
    subtitle:
      'The rule book: when things change state. The app uses these numbers, and Claude follows them once it is connected.',
  },
  { group: 'Chasing' },
  { group: 'Counting' },
  { group: 'Claude', subtitle: 'How often Claude may start by itself. What you ask for by hand is never held back.' },
];

/** The rule book: one table per kind of rule, each with the number of days (or bookings) it waits for */
export function RuleBookPanels({
  draft,
  onChange,
}: {
  draft: Record<RuleId, string>;
  onChange: (id: RuleId, v: string) => void;
}) {
  return GROUPS.map(({ group, subtitle }) => (
    <Panel key={group} title={`Rule book: ${group}`} subtitle={subtitle}>
      <DataTable<(typeof RULES)[number]>
        rows={RULES.filter((r) => r.group === group)}
        rowKey={(r) => r.id}
        columns={[
          {
            header: 'Rule',
            primary: true,
            render: (r) => (
              <Box>
                <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{r.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {r.help}
                </Typography>
              </Box>
            ),
          },
          {
            header: 'Number',
            nowrap: true,
            render: (r) => (
              <NumberInput value={draft[r.id]} onChange={(v) => onChange(r.id, v)} label={r.label} after={r.unit} />
            ),
          },
          { header: 'Used on', render: (r) => r.appliesTo },
        ]}
      />
    </Panel>
  ));
}
